var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeCis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#2CB2A5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13979_182029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8575 12.9466H19.3773C18.5925 12.9466 17.9453 13.58 17.9453 14.3787V17.1601C17.9453 17.9449 18.5925 18.5921 19.3773 18.5921H24.8575C25.6424 18.5921 26.2895 17.9449 26.2895 17.1601V14.3787C26.2895 13.58 25.6562 12.9466 24.8575 12.9466ZM25.3395 17.1601C25.3395 17.4217 25.1329 17.642 24.8575 17.642H19.3773C19.1157 17.642 18.8954 17.4355 18.8954 17.1601V14.3787C18.8954 14.117 19.1019 13.8967 19.3773 13.8967H24.8575C25.1192 13.8967 25.3395 14.1033 25.3395 14.3787V17.1601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.568 15.8657H11.432C10.6334 15.8657 10 16.5129 10 17.2978V29.6076C10 30.3924 10.6334 31.0396 11.432 31.0396H32.568C33.3528 31.0396 34 30.3924 34 29.6076V17.2978C34 16.5129 33.3528 15.8657 32.568 15.8657ZM25.5318 24.031H23.0534V26.5232H21.1945V24.031H18.7022V22.1859H21.1945V19.6936H23.0534V22.1859H25.5456V24.031H25.5318Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13979_182029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.1067,
    fill: "white",
    transform: "translate(10 12.9466)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeCis);
export default __webpack_public_path__ + "static/media/PhanHeCIS.7808906a.svg";
export { ForwardRef as ReactComponent };